export const translations = {
  en: {
    welcome: "Welcome",
    dashboard: "Dashboard",
    patients: "Patients",
    messages: "Messages",
    alerts: "Alerts",
    settings: "Settings",
    darkMode: "Dark Mode",
    language: "Language",
    notifications: "Notifications",
    emailNotifications: "Email Notifications",
    smsNotifications: "SMS Notifications",
    appearance: "Appearance",
    riskThresholds: "Risk Thresholds",
    highRiskThreshold: "High Risk Threshold",
    moderateRiskThreshold: "Moderate Risk Threshold",
    saveSettings: "Save Settings",
    settingsSaved: "Settings saved successfully!",
    conversations: "Conversations",
    send: "Send",
    typeAMessage: "Type a message...",
    noConversations: "No conversations yet",
    selectConversation: "Select a conversation to start messaging",
    delete: "Delete",
    deleteMessage: "Delete message",
    areYouSure: "Are you sure?",
    deleteMessageConfirm: "This message will be deleted permanently.",
    cancel: "Cancel",
    confirm: "Confirm",
    deleteSuccess: "Message deleted successfully",
    noMessages: "No messages yet",
    realTimeECGMonitoring: "Real-Time ECG Monitoring",
    livePatientMonitoring: "Live patient monitoring and AI analysis",
    startLiveMonitoring: "Start Live Monitoring",
    stopMonitoring: "Stop Monitoring",
    onlinePatients: "Online Patients",
    todayECGs: "Today ECGs",
    activeAlerts: "Active Alerts",
    reportsGenerated: "Reports Generated",
    selectPatient: "Select Patient",
    liveECGMonitor: "Live ECG Monitor",
    patientVitals: "Patient Vitals",
    heartRate: "Heart Rate",
    spo2: "SpO2",
    temperature: "Temperature",
    respiratoryRate: "Respiratory Rate",
    aiAnalysis: "AI Analysis",
    confidence: "Confidence",
    highRisk: "High Risk",
    moderateRisk: "Moderate Risk",
    lowRisk: "Low Risk",
    normal: "Normal",
    recommendations: "Recommendations",
    recentAnalyses: "Recent Analyses",
    noAnalysisHistory: "No analysis history yet",
    startMonitoringToSee: "Start monitoring to see AI analysis",
    noActiveAlerts: "No active alerts",
    ECGRecords: "ECG Records",
    profile: "Profile",
    helpSupport: "Help & Support",
    reports: "Reports",
    devices: "Devices",
    users: "Users",
    simulator: "Simulator",
    logout: "Logout",
    searchPatient: "Search patient by name or ID...",
    alertsPage: "Alerts",
    patientsPage: "Patients",
    dashboardPage: "Dashboard"
  },
  fr: {
    welcome: "Bienvenue",
    dashboard: "Tableau de bord",
    patients: "Patients",
    messages: "Messages",
    alerts: "Alertes",
    settings: "Paramètres",
    darkMode: "Mode sombre",
    language: "Langue",
    notifications: "Notifications",
    emailNotifications: "Notifications par email",
    smsNotifications: "Notifications par SMS",
    appearance: "Apparence",
    riskThresholds: "Seuils de risque",
    highRiskThreshold: "Seuil de risque élevé",
    moderateRiskThreshold: "Seuil de risque modéré",
    saveSettings: "Enregistrer les paramètres",
    settingsSaved: "Paramètres enregistrés avec succès !",
    conversations: "Conversations",
    send: "Envoyer",
    typeAMessage: "Tapez un message...",
    noConversations: "Aucune conversation pour le moment",
    selectConversation: "Sélectionnez une conversation pour commencer",
    delete: "Supprimer",
    deleteMessage: "Supprimer le message",
    areYouSure: "Êtes-vous sûr ?",
    deleteMessageConfirm: "Ce message sera définitivement supprimé.",
    cancel: "Annuler",
    confirm: "Confirmer",
    deleteSuccess: "Message supprimé avec succès",
    noMessages: "Pas encore de messages",
    realTimeECGMonitoring: "Surveillance ECG en temps réel",
    livePatientMonitoring: "Surveillance en temps réel des patients et analyse IA",
    startLiveMonitoring: "Démarrer la surveillance en direct",
    stopMonitoring: "Arrêter la surveillance",
    onlinePatients: "Patients en ligne",
    todayECGs: "ECG du jour",
    activeAlerts: "Alertes actives",
    reportsGenerated: "Rapports générés",
    selectPatient: "Sélectionner un patient",
    liveECGMonitor: "Moniteur ECG en direct",
    patientVitals: "Signes vitaux du patient",
    heartRate: "Fréquence cardiaque",
    spo2: "SpO2",
    temperature: "Température",
    respiratoryRate: "Fréquence respiratoire",
    aiAnalysis: "Analyse IA",
    confidence: "Confiance",
    highRisk: "Risque élevé",
    moderateRisk: "Risque modéré",
    lowRisk: "Faible risque",
    normal: "Normal",
    recommendations: "Recommandations",
    recentAnalyses: "Analyses récentes",
    noAnalysisHistory: "Pas encore d'historique d'analyse",
    startMonitoringToSee: "Commencez la surveillance pour voir l'analyse IA",
    noActiveAlerts: "Aucune alerte active",
    ECGRecords: "Enregistrements ECG",
    profile: "Profil",
    helpSupport: "Aide & Support",
    reports: "Rapports",
    devices: "Appareils",
    users: "Utilisateurs",
    simulator: "Simulateur",
    logout: "Déconnexion",
    searchPatient: "Rechercher un patient par nom ou ID...",
    alertsPage: "Alertes",
    patientsPage: "Patients",
    dashboardPage: "Tableau de bord"
  },
  sw: {
    welcome: "Karibu",
    dashboard: "Dashibodi",
    patients: "Wagonjwa",
    messages: "Ujumbe",
    alerts: "Orodha ya taarifa",
    settings: "Mipangilio",
    darkMode: "Mode dhulumi",
    language: "Lugha",
    notifications: "Arifa",
    emailNotifications: "Arifa za barua pepe",
    smsNotifications: "Arifa za SMS",
    appearance: "Mwonekano",
    riskThresholds: "Vipimo vya hatari",
    highRiskThreshold: "Kiwango cha hatari ya juu",
    moderateRiskThreshold: "Kiwango cha hatari ya kati",
    saveSettings: "Hifadhi mipangilio",
    settingsSaved: "Mipangilio ilohifadhiwa kwa mafanikio!",
    conversations: "Mazungumzo",
    send: "Tuma",
    typeAMessage: "Andika ujumbe...",
    noConversations: "Hakuna mazungumzo bado",
    selectConversation: "Chagua mazungumzo ili kuanza",
    delete: "Futa",
    deleteMessage: "Futa ujumbe",
    areYouSure: "Una hakika?",
    deleteMessageConfirm: "Ujumbe huu utafutwa milele.",
    cancel: "Ghairi",
    confirm: "Thibitisha",
    deleteSuccess: "Ujumbe umefutwa kwa mafanikio",
    noMessages: "Hakuna ujumbe bado",
    realTimeECGMonitoring: "Uchunguzi wa ECG wa wakati halisi",
    livePatientMonitoring: "Uchunguzi wa wagonjwa wa wakati halisi na uchambuaishi wa AI",
    startLiveMonitoring: "Anza uchunguzi wa wakati halisi",
    stopMonitoring: "Acha uchunguzi",
    onlinePatients: "Wagonjwa wanaounga mtandao",
    todayECGs: "ECG ya leo",
    activeAlerts: "Orodha ya taarifa zilizopo",
    reportsGenerated: "Ripoti zilizotengenezwa",
    selectPatient: "Chagua mgonjwa",
    liveECGMonitor: "Kichunguzi cha ECG cha wakati halisi",
    patientVitals: "Vitu vya mgonjwa",
    heartRate: "Kasi ya moyo",
    spo2: "SpO2",
    temperature: "Joto",
    respiratoryRate: "Kasi ya kupumua",
    aiAnalysis: "Uchambuaishi wa AI",
    confidence: "Uthabiti",
    highRisk: "Hatari ya juu",
    moderateRisk: "Hatari ya kati",
    lowRisk: "Hatari ya chini",
    normal: "Kawaida",
    recommendations: "Mashauri",
    recentAnalyses: "Uchambuaishi wa hivi karibuni",
    noAnalysisHistory: "Hakuna historia ya uchambuaishi",
    startMonitoringToSee: "Anza uchunguzi ili kuona uchambuaishi wa AI",
    noActiveAlerts: "Hakuna orodha ya taarifa zilizopo",
    ECGRecords: "Rekodi za ECG",
    profile: "Profaili",
    helpSupport: "Msaada na Usaidizi",
    reports: "Ripoti",
    devices: "Vifaa",
    users: "Watumiaji",
    simulator: "Simuleta",
    logout: "Toka",
    searchPatient: "Tafuta mgonjwa kwa jina au ID...",
    alertsPage: "Orodha ya taarifa",
    patientsPage: "Wagonjwa",
    dashboardPage: "Dashibodi"
  },
  ar: {
    welcome: "مرحبا",
    dashboard: "لوحة القيادة",
    patients: "المرضى",
    messages: "رسائل",
    alerts: "تنبيهات",
    settings: "الإعدادات",
    darkMode: "الوضع الداكن",
    language: "اللغة",
    notifications: "الإشعارات",
    emailNotifications: "إشعارات البريد الإلكتروني",
    smsNotifications: "إشعارات الرسائل النصية",
    appearance: "المظهر",
    riskThresholds: "عتبات المخاطر",
    highRiskThreshold: "عتبة المخاطر العالية",
    moderateRiskThreshold: "عتبة المخاطر المعتدلة",
    saveSettings: "حفظ الإعدادات",
    settingsSaved: "تم حفظ الإعدادات بنجاح!",
    conversations: "المحادثات",
    send: "إرسال",
    typeAMessage: "اكتب رسالة...",
    noConversations: "لا توجد محادثات بعد",
    selectConversation: "حدد محادثة لبدء المراسلة",
    delete: "حذف",
    deleteMessage: "حذف الرسالة",
    areYouSure: "هل أنت متأكد؟",
    deleteMessageConfirm: "سيتم حذف هذه الرسالة نهائيًا.",
    cancel: "إلغاء",
    confirm: "تأكيد",
    deleteSuccess: "تم حذف الرسالة بنجاح",
    noMessages: "لا توجد رسائل بعد",
    realTimeECGMonitoring: "مراقبة ECG في الوقت الفعلي",
    livePatientMonitoring: "مراقبة المريض المباشرة وتحليل الذكاء الاصطناعي",
    startLiveMonitoring: "ابدأ المراقبة المباشرة",
    stopMonitoring: "إيقاف المراقبة",
    onlinePatients: "المرضى المتصلين",
    todayECGs: "ECG اليوم",
    activeAlerts: "التنبيهات النشطة",
    reportsGenerated: "التقارير المولدة",
    selectPatient: "اختر المريض",
    liveECGMonitor: "شاشة ECG المباشرة",
    patientVitals: "العلامات الحيوية للمريض",
    heartRate: "معدل ضربات القلب",
    spo2: "SpO2",
    temperature: "درجة الحرارة",
    respiratoryRate: "معدل التنفس",
    aiAnalysis: "تحليل الذكاء الاصطناعي",
    confidence: "الثقة",
    highRisk: "خطر مرتفع",
    moderateRisk: "خطر معتدل",
    lowRisk: "خطر منخفض",
    normal: "طبيعي",
    recommendations: "التوصيات",
    recentAnalyses: "التحليلات الأخيرة",
    noAnalysisHistory: "لا يوجد سجل تحليلات بعد",
    startMonitoringToSee: "ابدأ المراقبة لرؤية تحليل الذكاء الاصطناعي",
    noActiveAlerts: "لا توجد تنبيهات نشطة",
    ECGRecords: "سجلات ECG",
    profile: "الملف الشخصي",
    helpSupport: "المساعدة والدعم",
    reports: "التقارير",
    devices: "الأجهزة",
    users: "المستخدمون",
    simulator: "المحاكي",
    logout: "تسجيل الخروج",
    searchPatient: "ابحث عن المريض بالاسم أو المعرف...",
    alertsPage: "التنبيهات",
    patientsPage: "المرضى",
    dashboardPage: "لوحة القيادة"
  },
  es: {
    welcome: "Bienvenido",
    dashboard: "Panel de control",
    patients: "Pacientes",
    messages: "Mensajes",
    alerts: "Alertas",
    settings: "Configuración",
    darkMode: "Modo oscuro",
    language: "Idioma",
    notifications: "Notificaciones",
    emailNotifications: "Notificaciones por correo electrónico",
    smsNotifications: "Notificaciones por SMS",
    appearance: "Apariencia",
    riskThresholds: "Umbrales de riesgo",
    highRiskThreshold: "Umbral de riesgo alto",
    moderateRiskThreshold: "Umbral de riesgo moderado",
    saveSettings: "Guardar configuración",
    settingsSaved: "¡Configuración guardada exitosamente!",
    conversations: "Conversaciones",
    send: "Enviar",
    typeAMessage: "Escribe un mensaje...",
    noConversations: "Aún no hay conversaciones",
    selectConversation: "Selecciona una conversación para empezar",
    delete: "Eliminar",
    deleteMessage: "Eliminar mensaje",
    areYouSure: "¿Estás seguro?",
    deleteMessageConfirm: "Este mensaje se eliminará permanentemente.",
    cancel: "Cancelar",
    confirm: "Confirmar",
    deleteSuccess: "Mensaje eliminado exitosamente",
    noMessages: "Aún no hay mensajes",
    realTimeECGMonitoring: "Monitoreo ECG en tiempo real",
    livePatientMonitoring: "Monitoreo en vivo de pacientes y análisis de IA",
    startLiveMonitoring: "Iniciar monitoreo en vivo",
    stopMonitoring: "Detener monitoreo",
    onlinePatients: "Pacientes en línea",
    todayECGs: "ECGs de hoy",
    activeAlerts: "Alertas activas",
    reportsGenerated: "Informes generados",
    selectPatient: "Seleccionar paciente",
    liveECGMonitor: "Monitor ECG en vivo",
    patientVitals: "Signos vitales del paciente",
    heartRate: "Frecuencia cardíaca",
    spo2: "SpO2",
    temperature: "Temperatura",
    respiratoryRate: "Frecuencia respiratoria",
    aiAnalysis: "Análisis de IA",
    confidence: "Confianza",
    highRisk: "Alto riesgo",
    moderateRisk: "Riesgo moderado",
    lowRisk: "Bajo riesgo",
    normal: "Normal",
    recommendations: "Recomendaciones",
    recentAnalyses: "Análisis recientes",
    noAnalysisHistory: "Aún no hay historial de análisis",
    startMonitoringToSee: "Inicia el monitoreo para ver el análisis de IA",
    noActiveAlerts: "No hay alertas activas",
    ECGRecords: "Registros ECG",
    profile: "Perfil",
    helpSupport: "Ayuda y Soporte",
    reports: "Informes",
    devices: "Dispositivos",
    users: "Usuarios",
    simulator: "Simulador",
    logout: "Cerrar sesión",
    searchPatient: "Buscar paciente por nombre o ID...",
    alertsPage: "Alertas",
    patientsPage: "Pacientes",
    dashboardPage: "Panel de control"
  },
  de: {
    welcome: "Willkommen",
    dashboard: "Dashboard",
    patients: "Patienten",
    messages: "Nachrichten",
    alerts: "Warnungen",
    settings: "Einstellungen",
    darkMode: "Dunkler Modus",
    language: "Sprache",
    notifications: "Benachrichtigungen",
    emailNotifications: "E-Mail-Benachrichtigungen",
    smsNotifications: "SMS-Benachrichtigungen",
    appearance: "Erscheinungsbild",
    riskThresholds: "Risikoschwellen",
    highRiskThreshold: "Hoher Risikoschwellenwert",
    moderateRiskThreshold: "Mäßiger Risikoschwellenwert",
    saveSettings: "Einstellungen speichern",
    settingsSaved: "Einstellungen erfolgreich gespeichert!",
    conversations: "Unterhaltungen",
    send: "Senden",
    typeAMessage: "Schreibe eine Nachricht...",
    noConversations: "Noch keine Unterhaltungen",
    selectConversation: "Wähle eine Unterhaltung aus, um zu beginnen",
    delete: "Löschen",
    deleteMessage: "Nachricht löschen",
    areYouSure: "Bist du sicher?",
    deleteMessageConfirm: "Diese Nachricht wird endgültig gelöscht.",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    deleteSuccess: "Nachricht erfolgreich gelöscht",
    noMessages: "Noch keine Nachrichten",
    realTimeECGMonitoring: "Echtzeit-ECG-Überwachung",
    livePatientMonitoring: "Live-Patientenüberwachung und KI-Analyse",
    startLiveMonitoring: "Live-Überwachung starten",
    stopMonitoring: "Überwachung stoppen",
    onlinePatients: "Online-Patienten",
    todayECGs: "Heutige ECGs",
    activeAlerts: "Aktive Warnungen",
    reportsGenerated: "Generierte Berichte",
    selectPatient: "Patient auswählen",
    liveECGMonitor: "Live-ECG-Monitor",
    patientVitals: "Patientenvitalwerte",
    heartRate: "Herzfrequenz",
    spo2: "SpO2",
    temperature: "Temperatur",
    respiratoryRate: "Atemfrequenz",
    aiAnalysis: "KI-Analyse",
    confidence: "Konfidenz",
    highRisk: "Hohes Risiko",
    moderateRisk: "Moderates Risiko",
    lowRisk: "Niedriges Risiko",
    normal: "Normal",
    recommendations: "Empfehlungen",
    recentAnalyses: "Jüngste Analysen",
    noAnalysisHistory: "Noch keine Analysehistorie",
    startMonitoringToSee: "Starte die Überwachung, um die KI-Analyse zu sehen",
    noActiveAlerts: "Keine aktiven Warnungen",
    ECGRecords: "ECG-Daten",
    profile: "Profil",
    helpSupport: "Hilfe & Support",
    reports: "Berichte",
    devices: "Geräte",
    users: "Benutzer",
    simulator: "Simulator",
    logout: "Abmelden",
    searchPatient: "Patient nach Name oder ID suchen...",
    alertsPage: "Warnungen",
    patientsPage: "Patienten",
    dashboardPage: "Dashboard"
  },
  zh: {
    welcome: "欢迎",
    dashboard: "仪表板",
    patients: "患者",
    messages: "消息",
    alerts: "警报",
    settings: "设置",
    darkMode: "深色模式",
    language: "语言",
    notifications: "通知",
    emailNotifications: "电子邮件通知",
    smsNotifications: "短信通知",
    appearance: "外观",
    riskThresholds: "风险阈值",
    highRiskThreshold: "高风险阈值",
    moderateRiskThreshold: "中等风险阈值",
    saveSettings: "保存设置",
    settingsSaved: "设置保存成功！",
    conversations: "对话",
    send: "发送",
    typeAMessage: "输入消息...",
    noConversations: "还没有对话",
    selectConversation: "选择一个对话开始",
    delete: "删除",
    deleteMessage: "删除消息",
    areYouSure: "你确定吗？",
    deleteMessageConfirm: "这条消息将被永久删除。",
    cancel: "取消",
    confirm: "确认",
    deleteSuccess: "消息删除成功",
    noMessages: "还没有消息",
    realTimeECGMonitoring: "实时ECG监护",
    livePatientMonitoring: "实时患者监护和AI分析",
    startLiveMonitoring: "开始实时监护",
    stopMonitoring: "停止监护",
    onlinePatients: "在线患者",
    todayECGs: "今日ECG",
    activeAlerts: "活动警报",
    reportsGenerated: "生成的报告",
    selectPatient: "选择患者",
    liveECGMonitor: "实时ECG监护仪",
    patientVitals: "患者生命体征",
    heartRate: "心率",
    spo2: "血氧饱和度",
    temperature: "体温",
    respiratoryRate: "呼吸频率",
    aiAnalysis: "AI分析",
    confidence: "置信度",
    highRisk: "高风险",
    moderateRisk: "中等风险",
    lowRisk: "低风险",
    normal: "正常",
    recommendations: "建议",
    recentAnalyses: "最近分析",
    noAnalysisHistory: "还没有分析历史",
    startMonitoringToSee: "开始监护以查看AI分析",
    noActiveAlerts: "没有活动警报",
    ECGRecords: "ECG记录",
    profile: "个人资料",
    helpSupport: "帮助与支持",
    reports: "报告",
    devices: "设备",
    users: "用户",
    simulator: "模拟器",
    logout: "退出",
    searchPatient: "按姓名或ID搜索患者...",
    alertsPage: "警报",
    patientsPage: "患者",
    dashboardPage: "仪表板"
  },
  it: {
    welcome: "Benvenuto",
    dashboard: "Dashboard",
    patients: "Pazienti",
    messages: "Messaggi",
    alerts: "Avvisi",
    settings: "Impostazioni",
    darkMode: "Modalità scura",
    language: "Lingua",
    notifications: "Notifiche",
    emailNotifications: "Notifiche email",
    smsNotifications: "Notifiche SMS",
    appearance: "Aspetto",
    riskThresholds: "Soglie di rischio",
    highRiskThreshold: "Soglia di rischio alto",
    moderateRiskThreshold: "Soglia di rischio moderato",
    saveSettings: "Salva impostazioni",
    settingsSaved: "Impostazioni salvate con successo!",
    conversations: "Conversazioni",
    send: "Invia",
    typeAMessage: "Scrivi un messaggio...",
    noConversations: "Nessuna conversazione ancora",
    selectConversation: "Seleziona una conversazione per iniziare",
    delete: "Elimina",
    deleteMessage: "Elimina messaggio",
    areYouSure: "Sei sicuro?",
    deleteMessageConfirm: "Questo messaggio verrà eliminato definitivamente.",
    cancel: "Annulla",
    confirm: "Conferma",
    deleteSuccess: "Messaggio eliminato con successo",
    noMessages: "Nessun messaggio ancora",
    realTimeECGMonitoring: "Monitoraggio ECG in tempo reale",
    livePatientMonitoring: "Monitoraggio pazienti in tempo reale e analisi AI",
    startLiveMonitoring: "Avvia monitoraggio in tempo reale",
    stopMonitoring: "Arresta monitoraggio",
    onlinePatients: "Pazienti online",
    todayECGs: "ECG di oggi",
    activeAlerts: "Avvisi attivi",
    reportsGenerated: "Rapporti generati",
    selectPatient: "Seleziona paziente",
    liveECGMonitor: "Monitor ECG in tempo reale",
    patientVitals: "Parametri vitali paziente",
    heartRate: "Frequenza cardiaca",
    spo2: "SpO2",
    temperature: "Temperatura",
    respiratoryRate: "Frequenza respiratoria",
    aiAnalysis: "Analisi AI",
    confidence: "Confidenza",
    highRisk: "Alto rischio",
    moderateRisk: "Rischio moderato",
    lowRisk: "Basso rischio",
    normal: "Normale",
    recommendations: "Raccomandazioni",
    recentAnalyses: "Analisi recenti",
    noAnalysisHistory: "Ancora nessuna cronologia analisi",
    startMonitoringToSee: "Avvia il monitoraggio per vedere l'analisi AI",
    noActiveAlerts: "Nessun avviso attivo",
    ECGRecords: "Dati ECG",
    profile: "Profilo",
    helpSupport: "Aiuto e Supporto",
    reports: "Rapporti",
    devices: "Dispositivi",
    users: "Utenti",
    simulator: "Simulatore",
    logout: "Esci",
    searchPatient: "Cerca paziente per nome o ID...",
    alertsPage: "Avvisi",
    patientsPage: "Pazienti",
    dashboardPage: "Dashboard"
  }
};
